// services/funcService.js
// Routes legacy `callFunc` / `callFuncData` helpers through the new dedicated
// per-operation endpoints in PagesController (api/Pages/<FuncName>) instead of
// the removed VisualBase /func proxy.
import controllersApi from "./controllersApi";

/**
 * Calls the dedicated backend endpoint api/Pages/<name> with the given values.
 * Returns the full axios response so callers can read .status and .data.
 */
export const callFunc = (name, values = {}) => {
  return controllersApi.post(`api/Pages/${name}`, values);
};

/**
 * Same as callFunc, but returns response.data directly.
 */
export const callFuncData = async (name, values = {}) => {
  const res = await controllersApi.post(`api/Pages/${name}`, values);
  return res.data;
};
